// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"132":"30c204b2","493":"be1215d9","498":"f943b466","641":"9b948039","820":"f78148aa","981":"af2cc8d4","990":"049ec593"}[chunkId] + ".css";
};